module.exports = {"id":"215070","name":"Guillermo Ortíz","rating":"73","photo":"./data/images/photos/1/215070.png","club":{"name":"Santa Fe","logo":"./data/images/clubs/SantaFe.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GuillermoOrtiz0.json
// module id = 1662
// module chunks = 0